// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"index_tabContainer_1uhDJ","tabList":"index_tabList_23VQc","tab":"index_tab_2BRDT","active":"index_active_1_TSr","tabContent":"index_tabContent_1ycvS"};